import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import { Translate as T } from 'react-redux-i18n';

import { MAX_DOCUMENTS } from '../../../../constants';

type Props = {
  exceedsMaxDocuments: boolean;
};

const DocumentValidationNotification = ({ exceedsMaxDocuments }: Props) => {
  if (!exceedsMaxDocuments) {
    return null;
  }

  const key =
    'components.Report.CandidateStories.Modal.documents.error.documentLimit';
  const title = <T value={`${key}.title`} />;
  const subtitle = <T value={`${key}.subtitle`} maxDocuments={MAX_DOCUMENTS} />;

  return (
    <M.InlineNotification
      kind='error'
      title={title}
      subtitle={subtitle}
      className='error-message'
      data-testid='document-validation-notification'
      hideCloseButton
    />
  );
};

export default DocumentValidationNotification;
